import { questionnaireDefinitionFixtures } from "@/__mocks__/fixtures/questionnaireDefinitions";
import type { QuestionnaireAnswers } from "./QuestionnaireRenderer";
import QuestionnaireRenderer from "./QuestionnaireRenderer";

// TEMP: Fixture-backed dev entry point until questionnaire API and enrollment wiring are connected.
type QuestionnaireTestPanelProps = {
  onClose: () => void;
  initialAnswers?: QuestionnaireAnswers;
  onAnswersChange?: (answers: QuestionnaireAnswers) => void;
};

export default function QuestionnaireTestPanel({
  onClose,
  initialAnswers,
  onAnswersChange,
}: QuestionnaireTestPanelProps) {
  return (
    <QuestionnaireRenderer
      definitions={questionnaireDefinitionFixtures}
      initialAnswers={initialAnswers}
      onAnswersChange={onAnswersChange}
      onClose={onClose}
      showCompletionMessage
    />
  );
}
